<script setup>
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import {isCustomColor} from "../../../helpers/common";
import LiveDesigner from "../live-designer/LiveDesigner.vue";
import {computed, watchEffect, onUnmounted} from "vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const backgroundImage = computed(
    () => portalContentAndDesignStore.srcRoutes.public_page_background_image
);

const computedClasses = computed(() => {
    let classes = ["flex h-screen"];

    if (portalContentAndDesignStore.getPageBackgroundGradientColorClass) {
        classes.push(portalContentAndDesignStore.getPageBackgroundGradientColorClass);
    }

    if (backgroundImage.value && backgroundImage.value !== portalContentAndDesignStore.getFileUploadNoImageRoute) {
        classes.push("bg-cover bg-center");
    }

    return classes;
});

// Computed styles (for dynamic background images)
const computedStyles = computed(() => {
    let styles = {};
    if (backgroundImage.value && backgroundImage.value !== portalContentAndDesignStore.getFileUploadNoImageRoute) {
        styles.backgroundImage = `url(${backgroundImage.value})`;
    }
    return styles;
});

// Dynamic button text color CSS (reacts to live designer changes)
const btnTextStyleEl = document.createElement('style');
btnTextStyleEl.id = 'portal-btn-text-style';
document.head.appendChild(btnTextStyleEl);

watchEffect(() => {
    const color = portalContentAndDesignStore.portalLayoutSettings.public_page_content_button_text_color || 'white';
    let hex;
    if (isCustomColor(color)) {
        hex = color;
    } else if (color === 'black') {
        hex = '#000000';
    } else {
        hex = '#ffffff';
    }
    btnTextStyleEl.textContent = `button.portal-btn-text, a.portal-btn-text { color: ${hex}; }`;
});

// Dynamic content text color CSS (reacts to live designer changes)
const contentTextStyleEl = document.createElement('style');
contentTextStyleEl.id = 'portal-content-text-style';
document.head.appendChild(contentTextStyleEl);

watchEffect(() => {
    const color = portalContentAndDesignStore.portalLayoutSettings.public_page_content_text_color || 'gray-800';
    if (isCustomColor(color)) {
        contentTextStyleEl.textContent = `.text-custom-content-text { color: ${color}; }`;
    } else {
        contentTextStyleEl.textContent = '';
    }
});

onUnmounted(() => {
    btnTextStyleEl.remove();
    contentTextStyleEl.remove();
});

</script>

<template>
    <div
        v-if="portalContentAndDesignStore.portalInitialized"
        :class="[
            'flex',
            computedClasses,
            portalContentAndDesignStore.getPageBackgroundColorClass
        ]"
        :style="computedStyles"
        v-cloak
    >

        <live-designer v-if="portalContentAndDesignStore.liveDesignerEnabled" />

        <slot />

    </div>
</template>

